import { WebGLRenderer as w, OrthographicCamera as a, PerspectiveCamera as g, Scene as m, HemisphereLight as l } from "three";
function s({ canvas: t, orthographic: c, bgColor: f = 16777215, addLights: d, size: e, updateStyle: p }) {
  e || (t instanceof OffscreenCanvas ? e = [t.width, t.height] : e = [t.clientWidth, t.clientHeight]);
  const n = new w({ antialias: !0, canvas: t });
  n.setSize(e[0], e[1], p), n.setClearColor(f);
  let r;
  c ? r = new a(
    -e[0] * 0.5,
    e[0] * 0.5,
    e[1] * 0.5,
    -e[1] * 0.5,
    0.1,
    1e3
  ) : r = new g(
    70,
    e[0] / e[1],
    0.1,
    1e3
  );
  const i = new m();
  if (d) {
    const o = new l(16777215, 136);
    o.position.set(-1, 1.5, 1), i.add(o);
    const h = new l(16777215, 8912896, 0.5);
    h.position.set(-1, -1.5, -1), i.add(h);
  }
  return { renderer: n, camera: r, scene: i };
}
export {
  s as initThree
};
//# sourceMappingURL=index18.js.map
